/*
* This function is used to prevent trigger touchstart events on scroll
* Usage: Listen to click event of elements with class .tap and handle events as usual
*/

(function($){
  
  var hasMoved;

  $(document).on('touchstart', '.tap', onTouchStart);
  $(document).on('touchmove', '.tap', onTouchMove);
  $(document).on('touchend', '.tap', onTouchEnd);


  function onTouchStart(evt) {
    hasMoved = false;
  }

  function onTouchMove(evt) {
    hasMoved = true;
  }

  function onTouchEnd(evt) {
    if(!hasMoved) {
      evt.stopPropagation();
      evt.preventDefault();
      $(evt.target).trigger('click');
    }
  }

})(jQuery);